/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { ReactComponent as ArrowRight } from "cms/assets/icons/arrow-right.svg";
import { CircularProgress } from "@mui/material";
import { ReactComponent as House } from "cms/assets/icons/house.svg";
import { columns } from "./permit-table-columns";

const PermitList = (props) => {
    const {
        component = {},
        setSelectedPermit,
        permits,
        onChangeHandler,
        onSearchHandler,
        onSelectOption,
        resetFetch,
        queryValue,
        SearchFilterComp,
        isLoading,
    } = props || {};
    const { show_summary = true, show_header = true, selected_type = "housing", show_filter = true } = component;
    const permitTypeIconMap = {
        housing: House,
    };
    const permitTypeTitleMap = {
        housing: "Housing permits",
    };
    const PermitIcon = permitTypeIconMap[selected_type];
    const title = permitTypeTitleMap[selected_type];

    const handleRowClick = (params) => {
        const { row } = params;
        setSelectedPermit(row);
    };

    return (
        <div className="permit-list">
            {show_header && (
                <div className="permit-display-header">
                    <div className="permit-display-title">
                        <PermitIcon />
                        <h3>{title}</h3>
                    </div>
                    <Link to="/services/apply-for-a-permit">
                        Apply <ArrowRight />
                    </Link>
                </div>
            )}
            <div className="permit-display-content">
                {show_filter && SearchFilterComp && (
                    <div className="search-section">
                        <SearchFilterComp
                            onChangeHandler={onChangeHandler}
                            onSearchHandler={onSearchHandler}
                            onSelectOption={onSelectOption}
                            resetFetch={resetFetch}
                            queryValue={queryValue}
                        />
                    </div>
                )}

                {isLoading ? (
                    <div className="loading-permit">
                        <div className="loading-permit-img">
                            <CircularProgress />
                        </div>
                    </div>
                ) : (
                    <>
                        {show_summary && (
                            <p style={{ fontWeight: 500 }}>
                                <strong>{permits.length}</strong> results for recent permits
                            </p>
                        )}

                        {permits && (
                            <DataGrid
                                className="permit-data-grid"
                                columns={columns}
                                disableColumnMenu
                                disableColumnResize
                                disableColumnSelector
                                disableRowSelectionOnClick
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 5,
                                        },
                                    },
                                    sorting: {
                                        sortModel: [{ field: "issue_date", sort: "desc" }],
                                    },
                                }}
                                getRowHeight={() => "auto"}
                                onRowClick={handleRowClick}
                                pageSizeOptions={[5]}
                                rows={permits}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export { PermitList };
